import React, { FC } from "react";
import { Image, ImageProps } from "./Background.styles";

export const Background: FC<ImageProps> = ({ src }) => (
  <Image src={src} alt="" aria-hidden="true" />
);
